import { useContext, useEffect, useState } from "react";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import {
  BsFillBookmarkFill,
  BsFillPersonFill,
  BsHouseDoorFill,
  BsFillCalendar2WeekFill,
  BsLockFill,
  BsGenderFemale,
  BsFillTelephoneFill,
} from "react-icons/bs";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { HiMail } from "react-icons/hi";
import { RiErrorWarningFill } from "react-icons/ri";
import { AppSpan, AppText, Button, CustomContainer } from "src/style";
import { FlexRow } from "src/style";
import AdminPic from "src/assets/img/32.png";
import UserContext from "src/provider/state-manager/userProvider";
import ApiContext from "src/provider/API/call-service";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { IoMdTrash } from "react-icons/io";
import { MdEdit } from "react-icons/md";
import { Modal } from "src/component/Modal";
import { Header } from "src/component";
import { Select } from "src/component";
import {getMember,getClassList,getAllMemberInClass} from "src/utils/helpers";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { MemberTypeEnum } from "src/model";

const UserProfiles = () => {
  const {user,user: { profile }} = useContext(UserContext);
  const {
    info: {selectedMember, basicAppInfo },
    setSelectedMember,
    info,
    setEditUser,
  } = useContext(AppInfoContext);
  const [userDetail, setUserDetail] = useState<any | null>(null);
  const [showPassword, setShowPassword] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [memberClass, setMemberClass] = useState({ class: "" });
  const [member, setMember] = useState({ member: "" });
  const { API } = useContext(ApiContext);
  const navigate = useNavigate();
  const classList = getClassList(info);
  const memberList = getAllMemberInClass(info, memberClass.class);

  useEffect(() => {
    setUserDetail(getMember(basicAppInfo, selectedMember));
    setEditUser(getMember(basicAppInfo, selectedMember));
  }, [selectedMember]);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const closeModal = () => {
    setOpenModal(false);
  };

  const handleClassSelect = (key: string, value: string) => {
    setMemberClass({ ...memberClass, [key]: value });
  };
  const handleMemberSelect = (key: string, value: string) => {
    setMember({ ...member, [key]: value });
    setSelectedMember(value);
  };
  const handleDelete = (id: any) => {
    API.deleteMember(id);
    closeModal();
  };
  const handleNavigate = () => {
    navigate("/dashboard/edit-profile");
  };
  return (
    <div className="userProfile">
      <Modal open={openModal} cancel={closeModal} className="edit-user-modal">
        <div className="confirmation">
          <AppText color="black" fontWeight="600" textSize="1.6" align="center">
            Are you sure you want to delete this user?
          </AppText>
        </div>
        <FlexRow justifyContent="space-between" className="btn-container">
          <Button
            hoverColor="#A77B37"
            className="edit-user-btn cancel"
            onClick={closeModal}
          >
            <AiOutlineClose size={17} />
            Cancel
          </Button>
          <Button
            hoverBgColor="#fff"
            hoverColor="#A77B37"
            borderColor="#A77B37"
            className="edit-user-btn confirm"
            onClick={() => handleDelete(userDetail?._id)}
          >
            <AiOutlineCheck size={17} /> Confirm
          </Button>
        </FlexRow>
      </Modal>
      <Header user={user}>
        {profile.memberType !== MemberTypeEnum.STUDENT && (
          <FlexRow className="grid" gap="2" width="50">
            <Select
              label="Class"
              list={classList}
              placeholder="Select Member Class"
              handleSelect={handleClassSelect}
              labelColor="#fff"
              labelSize="1.2"
              name="class"
            />
            {memberClass.class && (
              <Select
                label="Member"
                list={memberList}
                placeholder="Select Member"
                handleSelect={handleMemberSelect}
                labelColor="#fff"
                labelSize="1.2"
                name="member"
              />
            )}
          </FlexRow>
        )}
      </Header>
      {userDetail || profile.memberType === MemberTypeEnum.STUDENT ? (
        <CustomContainer
          bgColor="#FFF5E5"
          height="auto"
          topMargin="2"
          radius=".5"
          bottomPadding="3"
          topPadding="3"
          leftPadding="3"
          rightPadding="3"
          className="details-container"
        >
          <FlexRow justifyContent="space-between" wrap="wrap" gap="2">
            <div className="student__bio">
              <img src={AdminPic} alt="" className="student__bio-pic" />
              <AppText 
                lang="de" color="#712126" textSize="2.4" 
                className="user-profile-name"
              >
                {profile?.memberType === MemberTypeEnum.STUDENT
                  ? profile?.firstName
                  : userDetail?.firstName}&nbsp;
                {profile?.memberType === MemberTypeEnum.STUDENT
                  ? profile?.surname
                  : userDetail?.surname}
              </AppText>
              <AppText color="#374957" fontWeight="700">
                <AppSpan fontWeight="400" color="rgba(0,0,0,.7)">
                  ID:&nbsp;
                </AppSpan>
                {profile?.memberType === MemberTypeEnum.STUDENT
                  ? profile?.regId
                  : userDetail?.regId}
              </AppText>
            </div>
            <AppText
              color="#374957"
              style={{ display: "inline-block" }}
              textSize="2"
            >
              <AppSpan color="#374957" fontWeight="400" textSize="2">
                Designation: &nbsp;
              </AppSpan>
              {profile?.memberType === MemberTypeEnum.STUDENT
                ? profile?.memberType
                : userDetail?.memberType}
            </AppText>
            {profile.memberType === MemberTypeEnum.ADMIN && (
              <FlexRow gap="2" width="auto" className="btn-container">
                <Button
                  width="13"
                  bgColor="#D4D4D4"
                  color="#374957"
                  hoverBgColor="red"
                  hoverColor="#fff"
                  onClick={() => setOpenModal(!openModal)}
                  fontWeight="500"
                  className="btn-del"
                >
                  <IoMdTrash size={20} /> Delete
                </Button>
                <Button
                  width="13"
                  bgColor="#A77B37"
                  color="#fff"
                  hoverBgColor="#712126"
                  onClick={handleNavigate}
                  fontWeight="500"
                  className="btn-edit"
                >
                  <MdEdit size={20} /> Edit
                </Button>
              </FlexRow>
            )}
          </FlexRow>

          <table className="userProfile__table">
            <tbody>
              <tr>
                <td>
                  <div className="userProfile__table-grid">
                    <BsFillPersonFill
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />

                    <AppText color="#374957" fontWeight="400">
                      Firstname
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile?.firstName
                        : userDetail?.firstName}
                    </AppText>
                  </div>
                </td>
                <td>
                  <div className="userProfile__table-grid">
                    <BsFillPersonFill
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />
                    <AppText color="#374957" fontWeight="400">
                      Lastname
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile?.surname
                        : userDetail?.surname}
                    </AppText>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="userProfile__table-grid">
                    <BsFillPersonFill
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />
                    <AppText color="#374957" fontWeight="400">
                      Username
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile?.username
                        : userDetail?.username}
                    </AppText>
                  </div>
                </td>
                <td>
                  <div className="userProfile__table-grid">
                    <HiMail
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />
                    <AppText color="#374957" fontWeight="400">
                      Email
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile?.email
                        : userDetail?.email}
                    </AppText>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="userProfile__table-grid">
                    <BsFillTelephoneFill
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />
                    <AppText color="#374957" fontWeight="400">
                      Phone Number
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile?.phoneNumber
                        : userDetail?.phoneNumber}
                    </AppText>
                  </div>
                </td>
                <td>
                  <div className="userProfile__table-grid">
                    <BsHouseDoorFill
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />
                    <AppText color="#374957" fontWeight="400">
                      Address
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile?.address
                        : userDetail?.address}
                    </AppText>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="userProfile__table-grid">
                    <BsGenderFemale
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />
                    <AppText color="#374957" fontWeight="400">
                      Gender
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile?.gender
                        : userDetail?.gender}
                    </AppText>
                  </div>
                </td>
                <td>
                  <div className="userProfile__table-grid">
                    <RiErrorWarningFill
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />
                    <AppText color="#374957" fontWeight="400">
                      Designation
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile?.memberType
                        : userDetail?.memberType}
                    </AppText>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="userProfile__table-grid">
                    <BsFillBookmarkFill
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />
                    <AppText color="#374957" fontWeight="400">
                      Class
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile.memberClass
                        : userDetail?.memberClass}
                    </AppText>
                  </div>
                </td>
                <td>
                  <div className="userProfile__table-grid">
                    <BsFillCalendar2WeekFill
                      color="#B8B8B8"
                      size={20}
                      className="userProfile__table--icon"
                    />
                    <AppText color="#374957" fontWeight="400">
                      Registration Date
                    </AppText>
                    <AppText
                      color="#712126"
                      textSize="2"
                      className="userProfile__name"
                    >
                      {profile?.memberType === MemberTypeEnum.STUDENT
                        ? profile?.regDate
                        : userDetail?.regDate}
                    </AppText>
                  </div>
                </td>
              </tr>
              {profile.memberType === MemberTypeEnum.ADMIN ? 
              <tr>
                <td>
                  <FlexRow justifyContent="space-between">
                    <div className="userProfile__table-grid">
                      <BsLockFill
                        color="#B8B8B8"
                        size={20}
                        className="userProfile__table--icon"
                      />
                      <AppText color="#374957" fontWeight="400">
                        Password
                      </AppText>
                      <AppText
                        color="#712126"
                        textSize="2"
                        className="userProfile__name"
                      >
                        {showPassword
                          ? profile?.memberType === MemberTypeEnum.STUDENT
                            ? profile?.passRecovery
                            : userDetail?.passRecovery
                          : "........."}
                      </AppText>
                    </div>
                    <div onClick={handleShowPassword}>
                      {showPassword ? (
                        <FaEye color="#B8B8B8" size={20} />
                      ) : (
                        <FaEyeSlash color="#B8B8B8" size={20} />
                      )}
                    </div>
                  </FlexRow>
                </td>
                <td></td>
              </tr> : null }
            </tbody>
          </table>
        </CustomContainer>
      ) : null}
    </div>
  );
};

export default UserProfiles;
